import Component from '../component';

export default class SliderVideo extends Component {
    constructor(...args) {
        super(...args);

        this.indexVideoPrev = 0;
        this.intervalDuration = 6000;
        this.isPaused = false;
    }

    init() {

        //Video
        this.dom.play = this.dom.component.querySelectorAll(".play");
        this.dom.overlay = this.dom.component.querySelectorAll(".overlay");
        this.dom.video = this.dom.component.querySelectorAll(".video");

        //Slider
        this.dom.containerVideo = this.dom.component.querySelectorAll('.container-video');
        this.lengthSlide = this.dom.video.length - 1;

    }

    bind() {
        super.bind();

        //Click player video
        for (let i = 0; i < this.dom.play.length; i++) {
            this.dom.play[i].addEventListener("click", () => {
                TweenLite.to(this.dom.overlay[i], 0.5, {
                    autoAlpha: 0
                });
                this.dom.video[i].play();
            });
        }

        //Event playing video
        for (let i = 0; i < this.dom.video.length; i++) {
            this.dom.video[i].addEventListener("playing", () => {
                this.isPaused = true;
            });
        }

    }


    /*

    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/slider-video/slider-video.js